<template>
  <div class="app">
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Identify-Bill-Type") }} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search3"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click="insertFisTipiOpen()"
                flat
              >
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">Fiş Tipi Ekle</span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{
                $t("Limited-Authorization")
              }}</span>
              <span v-if="sayfayetki.Save">Fiş Tipi Ekle</span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headersFisTipi"
        :rows-per-page-items="[50, 100]"
        :loading="progress"
        :items="items"
        :search="search3"
      >
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.ID }}</td>
            <td class="text-xs-left">{{ props.item.RecieptTypeName }}</td>
            <td class="justify-end align-center full-heigth layout px-0">
              <v-btn
                v-if="sayfayetki.Update"
                @click="editDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="info">search</v-icon>
              </v-btn>
              <v-btn
                v-if="sayfayetki.Delete"
                @click="deleteDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="warning">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t("No-records-searched-for", { value: search3 }) }}
        </v-alert>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDataDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">Fiş Tipi Düzenle</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field
            v-model="fisTipiLoadData.RecieptTypeName"
            :label="$t('Bill-Type')"
          ></v-text-field>
          <v-radio-group v-model="fisTipiLoadData.Type">
            <v-radio :label="$t('tab_general')" :value="0"></v-radio>
            <v-radio :label="$t('Opening-Receipt')" :value="1"></v-radio>
            <v-radio :label="$t('Closing-Bill')" :value="2"></v-radio>
            <v-radio label="Tahsil" :value="3"></v-radio>
            <v-radio label="Tediye" :value="4"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="editDataDialog = false" outline color="warning">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outline color="info" @click="UpdateFisTipi()">
            {{ $t("Update") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="insertDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">Fiş Tipi Ekle</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <v-text-field
            v-model="fisTipiData.RecieptTypeName"
            label="Fiş Tipi Adı"
          ></v-text-field>
          <v-radio-group v-model="fisTipiData.Type">
            <v-radio :label="$t('tab_general')" :value="0"></v-radio>
            <v-radio :label="$t('Opening-Receipt')" :value="1"></v-radio>
            <v-radio :label="$t('Closing-Bill')" :value="2"></v-radio>
            <v-radio label="Tahsil" :value="3"></v-radio>
            <v-radio label="Tediye" :value="4"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="insertDialog = false" outline color="warning">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outline color="info" @click="insertFisTipi()">
            {{ $t("save_button") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text">Fiş Tipi Sil</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t("Are-you-sure-want-delete") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outline color="info" @click="deleteFisTipi()">
            {{ $t("Delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import auth from "@/api/auth";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  data() {
    return {
      loadingvmodel: false,
      editDataDialog: false,
      insertDialog: false,
      deleteDialog: false,
      deleteData: {
        ID: 0,
        RecieptTypeName: null,
      },
      text1: null,
      snackbar: false,
      yetkidialog: false,
      headersFisTipi: [
        {
          text: "ID",
          value: "ID",
          align: "left",
        },
        {
          text: this.$t("Bill-Type"),
          value: "RecieptTypeName",
          align: "left",
        },
      ],
      fisTipiData: {
        ID: 0,
        RecieptTypeName: null,
        Type: 0,
      },
      fisTipiLoadData: {
        ID: 0,
        RecieptTypeName: null,
        Type: 0,
      },
      loading: false,
      progress: false,
      items: [],
      search3: "",
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  components: {
    tool,
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  methods: {
    deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteData = val;
    },
    deleteFisTipi() {
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/RecieptTypeDelete",
          this.deleteData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
             this.text1 = this.$t(response.body.ResponseMessage);
            this.snackbar = true;
            this.deleteDialog = false;
            this.loadingvmodel = false;
            this.getFisTipiList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptTypeDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptTypeDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    insertFisTipi() {
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/RecieptTypeSave",
          this.fisTipiData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
             this.text1 = this.$t(response.body.ResponseMessage);
            this.snackbar = true;
            this.insertDialog = false;
            this.loadingvmodel = false;

            this.getFisTipiList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptTypeSave";
              this.snackbar = true;
              this.insertDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptTypeSave";
              this.snackbar = true;
              this.insertDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    insertFisTipiOpen() {
      this.fisTipiData.RecieptTypeName = null;
      this.insertDialog = true;
    },
    UpdateFisTipi() {
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/RecieptTypeSave",
          this.fisTipiLoadData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
             this.text1 = this.$t(response.body.ResponseMessage);
            this.snackbar = true;
            this.getFisTipiList();
            this.editDataDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptTypeSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptTypeSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    editDialogOpen(val) {
      var params = {
        ID: val.ID,
        RecieptTypeName: val.RecieptTypeName,
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/RecieptTypeLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.fisTipiLoadData = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingCompanyLoad";
              this.snackbar = true;
            }
          }
        );
      this.editDataDialog = true;
    },
    getFisTipiList() {
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/RecieptTypeList",
          null,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.items = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.getFisTipiList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>